import * as THREE from 'three';
import { getPalette } from './palette';

/**
 * Dirt crossroads through the spawn pad: two crossing strips + dashed center lines.
 * Renders just above terrain (y offset + polygonOffset) to avoid z-fighting.
 */
export function buildRoads(scene: THREE.Scene, groundY: number): THREE.Group {
  const group = new THREE.Group();
  const pal = getPalette();
  const roadHex = pal.colors.road_dark?.hex ?? '#3A3F45';

  const roadMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(roadHex),
    roughness: 1.0,
    metalness: 0.0,
    polygonOffset: true,
    polygonOffsetFactor: -1,
  });
  const lineMat = new THREE.MeshBasicMaterial({
    color: 0xf5f0e8,
    polygonOffset: true,
    polygonOffsetFactor: -2,
  });

  const LEN = 60;
  const W = 6;
  const Y = groundY + 0.02;

  // Two crossing strips
  for (const rotY of [0, Math.PI / 2]) {
    const strip = new THREE.Mesh(new THREE.PlaneGeometry(LEN, W), roadMat);
    strip.rotation.x = -Math.PI / 2;
    strip.rotation.z = rotY;
    strip.position.y = Y;
    strip.receiveShadow = true;
    group.add(strip);
  }

  // Dashed center lines: 8 dashes per axis
  for (let i = -4; i < 4; i++) {
    const xDash = new THREE.Mesh(new THREE.PlaneGeometry(2.2, 0.25), lineMat);
    xDash.rotation.x = -Math.PI / 2;
    xDash.position.set(i * 6.5, Y + 0.01, 0);
    group.add(xDash);
    const zDash = new THREE.Mesh(new THREE.PlaneGeometry(0.25, 2.2), lineMat);
    zDash.rotation.x = -Math.PI / 2;
    zDash.position.set(0, Y + 0.01, i * 6.5);
    group.add(zDash);
  }

  scene.add(group);
  return group;
}
